// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"wzRF1JS","ratingContainer":"wzRF1JS","rating":"oaIwSGm","score":"xB_L8t1","star":"NQHCF9G","count":"muceQmu"};